import React from "react";

const Border = ({ children }) => {
  return <div className="border border-Brown rounded-xl overflow-hidden">{children}
  </div>;
};

export default Border;
